/* eslint-disable class-methods-use-this */
import API from '@/service/api'

class AuthService {
  login(user) {
    return API()
      .post('/auth/local', {
        identifier: user.identifier,
        password: user.password,
      })
      .then(response => {
        // Handle success.

        if (response.data.jwt) {
          localStorage.setItem('user', JSON.stringify(response.data))
        }

        return response.data
      })
      .catch(error => {
        // Handle error.
        console.error('Authentication failed:', error.response?.status || 'Unknown error')
        throw error
      })
  }

  logout() {
    localStorage.removeItem('user')
  }
}
export default new AuthService()
